exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-wrapper[data-v-12f9e300]{margin-bottom:4px;margin-right:4px;display:inline-block}.promoted-content-title[data-v-12f9e300]{display:inline-block;margin-right:5px}.promoted-content-badge[data-v-12f9e300],.promoted-content-badge[data-v-12f9e300] .search-within-badge__text{max-width:350px}", ""]);

// exports
